import { ActionResponseModalComponent } from '../action-response-modal/action-response-modal.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { DialogService } from 'primeng/dynamicdialog';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'underscore';
import { Title } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { DataService } from 'src/app/shared/services/data.service';
import { Action } from 'src/app/shared/models/action';
import { Paginator } from 'primeng/paginator';
import { TranslateService } from '@devinforius/i-essentials';
import { ServicesService } from 'src/app/shared/services/services.service';
import { ConfigDto, ContactDto, GroupsGlobalDto, LowInformationContactDto, ServiceDto } from 'src/app/shared/interfaces';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { UsersService } from 'src/app/shared/services/users.service';
import { UserDto } from 'src/app/shared/interfaces/users';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { MailsService } from 'src/app/shared/services/mails.service';
import { MeService } from 'src/app/shared/services/me.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { PersonalParams } from 'src/app/shared/models/iCourrier/me/personal-params';
import { ActionsService } from 'src/app/shared/services/actions.service';
import { UserInfosDetails } from 'src/app/shared/models/iCourrier/me/user-info';
import { ActionStatutDTO } from 'src/app/shared/interfaces/actions/action-statut-dto.interface';
import { ActionTypesDTO } from 'src/app/shared/interfaces/actions/action-types-dto.interface';
import { MailsEcheancierParams } from 'src/app/shared/models/mails/mails-echeancier';
import { MailEcheancierSearchResultPaginatedDTO } from 'src/app/shared/interfaces/mails/mail-echeancier-dto.interface';
import { environment } from 'src/environments/environment';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import { ITabs } from '@devinforius/i-navigation';
import { ITab } from '@devinforius/i-navigation/lib/models/i-tabsXl';
import { SearchActionPaginationDTO } from 'src/app/shared/interfaces/actions/action-pagination-dto.interface';
import { SearchActionPagination } from 'src/app/shared/models';
import { GroupsService } from 'src/app/shared/services/groups.service';
import { setServiceDescription } from 'src/app/utils/set-service-description.utils';
@Component({
  selector: 'app-home-action',
  templateUrl: './home-action.component.html',
  styleUrls: ['./home-action.component.scss'],
  providers: [DialogService],
})
export class HomeActionComponent implements OnInit {
  @ViewChild('pgAll', { static: true }) pgAll: Paginator;
  @ViewChild('pgWeek', { static: true }) pgWeek: Paginator;
  @ViewChild('pgFinished', { static: true }) pgFinished: Paginator;
  @ViewChild('pgAsked', { static: true }) pgAsked: Paginator;
  @ViewChild('pgAssignedToMyTeam', { static: true }) pgAssignedToMyTeam: Paginator;

  public week = moment().subtract(7, 'days').valueOf(); // format ms

  public actionStatus: ActionStatutDTO[] = [];
  public actionTypes: ActionTypesDTO[] = [];

  public userInfos: UserInfosDetails;

  public showActionResponse = false;
  public responseStatus = '';

  public actionsCount = 0;
  public actionsListAll: SearchActionPagination;
  public actionsListWeek: SearchActionPagination;
  public actionsListLate: SearchActionPagination;
  public actionsListFinish: SearchActionPagination;
  public actionsListAsked: SearchActionPagination;
  public actionsListAssignedToMyTeam: SearchActionPagination;

  public actionTabsActive = 'week';
  public actionTabs: ITab[] = [
    {
      label: 'A faire',
      id: 'week',
      count: 0,
      icon: 'actions_a_faire',
    },
    {
      label: 'Demandées par moi',
      id: 'asked',
      count: 0,
      icon: 'actions_demandees_par_moi',
    },
    {
      label: 'Terminées',
      id: 'finished',
      count: 0,
      icon: 'actions_terminees',
    },
    {
      label: 'Toutes',
      id: 'all',
      count: 0,
      icon: 'actions_toutes',
    },
  ];
  public columns = [];
  public allUsers: UserDto[] = [];
  public services: ServiceDto[] = [];
  public contacts: Contact[] = [];
  public groups: GroupsGlobalDto[] = [];

  public sizeChoice = 100;
  public sizeChoiceList: { label: string; value: number }[] = [
    { label: 'week', value: 100 },
    { label: 'asked', value: 100 },
    { label: 'assignedToMyTeam', value: 100 },
    { label: 'finished', value: 100 },
    { label: 'all', value: 100 },
  ];
  public sizeOfPages: { label: string; value: number }[] = [
    { label: 'Maximum 100 actions affichées pour le tableau', value: 100 },
    { label: 'Maximum 200 actions affichées pour le tableau', value: 200 },
    { label: 'Maximum 500 actions affichées pour le tableau', value: 500 },
    { label: 'Maximum 1000 actions affichées pour le tableau', value: 1000 },
    { label: 'Maximum 5000 actions affichées pour le tableau', value: 5000 },
  ];
  public sizeOfPagesPaginator: { label: string; value: number }[] = [
    { label: '100', value: 100 },
    { label: '200', value: 200 },
    { label: '500', value: 500 },
    { label: '1000', value: 1000 },
    { label: '5000', value: 5000 },
  ];
  public typeOfActionChosen = 'all';
  public typeOfActionsOptions: ITabs[] = [
    { header: 'Toutes', id: 'all', active: true },
    { header: 'En cours', id: 'onGoing' },
    { header: 'Terminées', id: 'finished' },
  ];

  public searchString = '';
  public justifyOptions: { icon: string; state: string }[] = [
    { icon: 'bi bi-view-list', state: 'list' },
    { icon: 'bi bi-table', state: 'table' },
  ];
  public valueJustifyOption: { icon: string; state: string };

  public columnSelected = null;

  public isUserResponsableService = false;

  public firstAll = 0;
  public firstWeek = 0;
  public firstFinished = 0;
  public firstAsked = 0;
  public firstAssignedToMyTeam = 0;
  public dataSearch = null;
  public excludedKeys = {
    excludedKeys: ['action', 'contact', 'dateEcheance', 'mailId', 'serviceProprietaireId', 'typeEntrantSortant'],
  };
  public actionSearchDropdown = null;
  public actionMembresServiceSearchDropdown = null;
  public actionMembresService: { label: string; value: number }[] = [];
  public isLoaded = false;
  public superTableLoaded = false;

  public appConfig: ConfigDto = null;
  constructor(
    private titleService: Title,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private dataService: DataService,
    private dialogService: DialogService,
    private translater: TranslateService,
    private servicesService: ServicesService,
    private usersService: UsersService,
    private contactsService: ContactsService,
    private meService: MeService,
    private configService: ConfigService,
    private actionsService: ActionsService,
    private mailsService: MailsService,
    private groupsService: GroupsService
  ) { }

  ngOnInit(): void {
    this.dataService.setSidebarSmall(false);
    this.titleService.setTitle(this.translater.translate('tabsTitle.actions'));
    this.spinner.show(); // hide it at the end of buildActionArray
    this.getUserInfos();
    this.getCustomView();
  }

  getCustomView(): void {
    const viewSelectButton = localStorage.getItem('iCourrier_Actions_Table_List_Visibility_Value');
    if (viewSelectButton) {
      this.valueJustifyOption = this.justifyOptions.find((x) => x.state === viewSelectButton);
    } else {
      this.valueJustifyOption = this.justifyOptions[0];
    }
    this.meService.getMyPersonalParams('CourrierCustomViews').subscribe({
      next: (res: PersonalParams[]) => {
        if (res && res.length > 0) {
          const actionAll = res.filter((x) => x.name === 'actionSuperTablesAll');

          if (actionAll.length > 0) {
            localStorage.setItem('state-of-table-actionSuperTablesAll', _.first(actionAll).value);
          }

          const actionWeek = res.filter((x) => x.name === 'actionsSuperTableWeeks');
          if (actionWeek.length > 0) {
            localStorage.setItem('state-of-table-actionsSuperTableWeeks', _.first(actionWeek).value);
          }

          const actionFinished = res.filter((x) => x.name === 'actionsSuperTableFinishs');
          if (actionFinished.length > 0) {
            localStorage.setItem('state-of-table-actionsSuperTableFinishs', _.first(actionFinished).value);
          }

          const actionAsked = res.filter((x) => x.name === 'actionsSuperTableAsked');
          if (actionAsked.length > 0) {
            localStorage.setItem('state-of-table-actionsSuperTableAsked', _.first(actionAsked).value);
          }

          const actionAssignedToMyTeam = res.filter((x) => x.name === 'actionsSuperTableAssignedToMyTeam');
          if (actionAssignedToMyTeam.length > 0) {
            localStorage.setItem('state-of-table-actionsSuperTableAssignedToMyTeam', _.first(actionAssignedToMyTeam).value);
          }
        }
      },
    });
  }

  saveColumn(event, name): void {
    const data = {
      name: name,
      description: 'Les colonnes de ' + name,
      value: event,
      shared: true,
      displayOrder: 0,
      hideInDashboard: true,
    };

    let currentView: PersonalParams;

    this.meService.getMyPersonalParams('CourrierCustomViews', name).subscribe({
      next: (res: PersonalParams[]) => {
        currentView = res?.length ? _.first(res) : null;
        if (currentView !== null) {
          this.meService.putMyPersonalParams(currentView.id, 'CourrierCustomViews', data).subscribe({
            next: () => {
              this.toastr.success('Vos choix ont été sauvegardé');
            },
          });
        } else {
          this.meService.postMyPersonalParams('CourrierCustomViews', data).subscribe({
            next: () => {
              this.toastr.success('Vos choix ont été sauvegardé');
            },
          });
        }
      },
    });
  }

  /**
   * Retreive data of connected user
   * if contactId not nul => retreive firstname & lastname
   * initData if userInfos is not null (initData = actions)
   */
  getUserInfos(): void {
    this.meService
      .getUserInfo()
      .pipe(
        tap((res) => (this.userInfos = res)),
        switchMap(() => this.getContactById(this.userInfos.contactId))
      )
      .subscribe({
        next: (res: ContactDto) => {
          this.userInfos.name = `${res.nom ? res.nom + ' ' : ''}${res.prenom}`;
          this.meService.fetchMyOwnServices().subscribe({
            next: (userServices) => {
              userServices.map((x) => {
                if (x.responsableService) {
                  this.isUserResponsableService = true;
                }
              });

              this.handleAppConfig();
            },
            error: (err: HttpErrorResponse) => {
              console.error(err);
              this.toastr.error('Impossible de récupérer les services de la personne connectée!');
            },
          });
        },
        error: (err: HttpErrorResponse) => {
          console.error(err);
          this.toastr.error('Impossible de récupérer les informations de la personne connectée!');
        },
      });
  }

  /**
   * Call api to retrieve data
   * Called by this.getUserInfos (need info of user connected )
   */
  private initData(): void {
    forkJoin({
      actionTypes: this.actionsService.getAllActionsTypes().pipe(
        catchError(() => {
          console.error(`Erreur lors de la récupérations des types d'actions`);
          return of([]);
        })
      ),
      services: this.servicesService.fetchServices().pipe(
        catchError(() => {
          console.error(`Erreur lors de la récupération des services`);
          return of([]);
        })
      ),
      statutes: this.actionsService.getAllActionsStatutes().pipe(
        catchError(() => {
          console.error(`Erreur lors de la récupération des status des actions`);
          return of([]);
        })
      ),
      users: this.usersService.fetchUsersFromiAdmin().pipe(
        catchError(() => {
          console.error(`Erreur lors de la récupération des utilisateurs`);
          return of([]);
        })
      ),
      contacts: this.contactsService.fetchContactsSummary('iCourrier').pipe(
        catchError(() => {
          console.error(`Erreur lors de la récupération des contacts`);
          return of([]);
        })
      ),
      serviceActionMembers: this.meService.getUsersInCharge().pipe(
        catchError(() => {
          console.error(`Erreur lors de la récupération des utilisateurs en charge`);
          return of([]);
        })
      ),
      actionsListAll: this.actionsService
        .getAllActionsMails({
          ContactId: this.userInfos.contactId,
        })
        .pipe(
          catchError(() => {
            console.error('Erreur lors de la récupération des actions des courriers');
            return of([]);
          })
        ),
      toDoActionsList: this.actionsService
        .getAllActionsMails({
          ContactId: this.userInfos.contactId,
          Traite: false,
        })
        .pipe(
          catchError(() => {
            console.error('Erreur lors de la récupération des actions des courriers non-traitées');
            return of([]);
          })
        ),
      doneActionsList: this.actionsService
        .getAllActionsMails({
          ContactId: this.userInfos.contactId,
          Traite: true,
        })
        .pipe(
          catchError(() => {
            console.error('Erreur lors de la récupération des actions des courriers traitées');
            return of([]);
          })
        ),
      askedByMeActionsList: this.actionsService
        .getAllActionsMails({
          TransmissionUserId: this.userInfos.id,
        })
        .pipe(
          catchError(() => {
            console.error('Erreur lors de la récupération des actions des courriers avec transmission');
            return of([]);
          })
        ),

      assignedToMyTeamActionsList: this.isUserResponsableService
        ? this.mailsService
          .getEcheancier({
            typeAction: 'AssignedToMyTeam',
            actionsEnCoursOnly: true,
            nePasInclurePourInformation: true,
          })
          .pipe(
            catchError(() => {
              console.error('Erreur lors de la récupération des actions des courriers en cours');
              return of([]);
            })
          )
        : of([]),
      groups: this.groupsService.fetchGlobalGroups().pipe(
        catchError(() => {
          console.error('Erreur lors de la récupération des groupes');
          return of([]);
        })
      ),
    }).subscribe({
      next: (res: {
        actionTypes: ActionTypesDTO[];
        services: ServiceDto[];
        statutes: ActionStatutDTO[];
        users: UserDto[];
        contacts: LowInformationContactDto[];
        serviceActionMembers: number[];
        actionsListAll: SearchActionPaginationDTO;
        toDoActionsList: SearchActionPaginationDTO;
        doneActionsList: SearchActionPaginationDTO;
        askedByMeActionsList: SearchActionPaginationDTO;
        assignedToMyTeamActionsList: MailEcheancierSearchResultPaginatedDTO;
        groups: GroupsGlobalDto[];
      }) => {
        this.actionTypes = res.actionTypes;
        this.services = res.services.map((service) => ({
          ...service,
          description: setServiceDescription(service),
        }));
        this.allUsers = res.users;
        this.contacts = res.contacts.map((contact) => new Contact(contact));
        this.groups = res.groups;

        if (res.statutes.length) {
          this.actionStatus = res.statutes.filter((actionStatute) => !actionStatute.notUsed && actionStatute.description);
        }

        this.actionMembresService = [];

        res.serviceActionMembers.forEach((id) => {
          const foundUser = this.allUsers.find((u) => u.userId === id);

          if (foundUser) {
            const newServiceActionMember = {
              label: `${foundUser.contactForUser?.nom ? foundUser.contactForUser?.nom + ' ' : ''}${foundUser.contactForUser?.prenom}`,
              value: id,
            };
            this.actionMembresService.push(newServiceActionMember);
          }
        });
        this.actionsListAll = new SearchActionPagination(res.actionsListAll);
        this.actionsListAll.items = this.actionsListAll.items.map((item) => new Action(item, this.allUsers, 'All', this.services, this.groups));
        this.actionTabs.find((tab) => tab.id === 'all').count = this.actionsListAll.totalCount;

        this.actionsListWeek = new SearchActionPagination(res.toDoActionsList);
        this.actionsListWeek.items = this.actionsListWeek.items.map((item) => new Action(item, this.allUsers, 'ToDo', this.services, this.groups));
        this.actionsListWeek.items = _.sortBy(this.actionsListWeek.items, (o) => moment(o.dateEcheance).format('YYYYMMDD'));
        this.actionTabs.find((tab) => tab.id === 'week').count = this.actionsListWeek.totalCount;

        this.actionsListFinish = new SearchActionPagination(res.doneActionsList);
        this.actionsListFinish.items = this.actionsListFinish.items.map(
          (item) => new Action(item, this.allUsers, 'Done', this.services, this.groups)
        );
        this.actionTabs.find((tab) => tab.id === 'finished').count = this.actionsListFinish.totalCount;

        this.actionsListAsked = new SearchActionPagination(res.askedByMeActionsList);
        this.actionsListAsked.items = this.actionsListAsked.items.map(
          (item) => new Action(item, this.allUsers, 'AskedByMe', this.services, this.groups)
        );
        this.actionTabs.find((tab) => tab.id === 'asked').count = this.actionsListAsked.totalCount;

        if (this.showAssignToMyTeamTab() && res.assignedToMyTeamActionsList) {
          this.actionsListAssignedToMyTeam = new SearchActionPagination(res.assignedToMyTeamActionsList);
          this.actionsListAssignedToMyTeam.items = res.assignedToMyTeamActionsList.items.map(
            (item) => new Action(item, this.allUsers, 'AssignedToMyTeam', this.services, this.groups)
          );
          this.actionTabs.find((tab) => tab.id === 'assignedToMyTeam').count = this.actionsListAssignedToMyTeam.totalCount;
        }

        this.isLoaded = true;
        this.superTableLoaded = true;

        this.spinner.hide();
      },
    });
  }

  private showAssignToMyTeamTab(): boolean {
    if (!this.isUserResponsableService) return false;

    const index: number = this.actionTabs.map((x) => x.id).indexOf('assignedToMyTeam');

    if (index === -1) {
      this.actionTabs.splice(2, 0, {
        label: 'Demandées aux membres de mes services',
        id: 'assignedToMyTeam',
        count: 0,
        icon: 'actions_demandees_membres_de_mes_services',
      });
    }

    return true;
  }

  private handleAppConfig(): void {
    this.configService.fetchConfig().subscribe({
      next: (res) => {
        this.appConfig = res;
        this.getColumns(res.mails.hideStatutAction);
      },
    });
  }

  paginate(type, pageNumber): void {
    this.spinner.show();
    this.superTableLoaded = false;
    const pageSize = this.sizeChoiceList.find((x) => x.label === type);
    if (type === 'all') {
      this.firstAll = (pageNumber - 1) * pageSize.value;
      const data = {
        ContactId: this.userInfos.contactId,
        PageNumber: pageNumber,
        PageSize: pageSize.value,
        Action: this.actionSearchDropdown,
      };

      if (!this.actionSearchDropdown) {
        delete data.Action;
      }

      this.actionsService.getAllActionsMails(data).subscribe({
        next: (response) => {
          this.actionsListAll = response;
          this.actionsListAll.items = this.actionsListAll.items.map((item) => {
            return (item = new Action(item, this.allUsers, 'All', this.services, this.groups));
          });
          this.actionTabs.find((x) => x.id === 'all').count = this.actionsListAll.totalCount;
          this.spinner.hide();
          this.superTableLoaded = true;
        },
        error: (error) => {
          console.error('Error : ', error);
          this.spinner.hide();
          this.toastr.error('Impossible de charger les actions!');
        },
      });
    }
    if (type === 'week') {
      this.firstWeek = (pageNumber - 1) * pageSize.value;
      const data = {
        ContactId: this.userInfos.contactId,
        Traite: false,
        PageNumber: pageNumber,
        PageSize: pageSize.value,
        Action: this.actionSearchDropdown,
      };
      if (!this.actionSearchDropdown) {
        delete data.Action;
      }

      this.actionsService.getAllActionsMails(data).subscribe({
        next: (response) => {
          this.actionsListWeek = response;
          this.actionsListWeek.items = this.actionsListWeek.items.map((item) => {
            return (item = new Action(item, this.allUsers, 'ToDo', this.services, this.groups));
          });
          this.actionTabs.find((x) => x.id === 'week').count = this.actionsListWeek.totalCount;
          this.spinner.hide();
          this.superTableLoaded = true;
        },
        error: (error) => {
          console.error('Error : ', error);
          this.spinner.hide();
          this.toastr.error('Impossible de charger les actions!');
        },
      });
    }
    if (type === 'finished') {
      this.firstFinished = (pageNumber - 1) * pageSize.value;
      const data = {
        ContactId: this.userInfos.contactId,
        Traite: true,
        PageNumber: pageNumber,
        PageSize: pageSize.value,
        Action: this.actionSearchDropdown,
      };
      if (!this.actionSearchDropdown) {
        delete data.Action;
      }
      this.actionsService.getAllActionsMails(data).subscribe({
        next: (response) => {
          this.actionsListFinish = response;

          this.actionsListFinish.items = this.actionsListFinish.items.map((item) => {
            return (item = new Action(item, this.allUsers, 'Done', this.services, this.groups));
          });

          this.actionTabs.find((x) => x.id === 'finished').count = this.actionsListFinish.totalCount;
          this.spinner.hide();
          this.superTableLoaded = true;
        },
        error: (error) => {
          console.error('Error : ', error);
          this.spinner.hide();
          this.toastr.error('Impossible de charger les actions!');
        },
      });
    }
    if (type === 'asked') {
      this.firstAsked = (pageNumber - 1) * pageSize.value;

      const data = {
        TransmissionUserId: this.userInfos.id,
        Traite: false,
        PageNumber: pageNumber,
        PageSize: pageSize.value,
        Action: this.actionSearchDropdown,
      };

      if (!this.actionSearchDropdown) {
        delete data.Action;
      }

      if (this.typeOfActionChosen === 'all') {
        delete data.Traite;
      } else if (this.typeOfActionChosen === 'onGoing') {
        data.Traite = false;
      } else if (this.typeOfActionChosen === 'finished') {
        data.Traite = true;
      }

      this.actionsService.getAllActionsMails(data).subscribe({
        next: (response) => {
          this.actionsListAsked = response;
          this.actionsListAsked.items = this.actionsListAsked.items.map((item) => {
            return (item = new Action(item, this.allUsers, 'AskedByMe', this.services, this.groups));
          });
          this.actionTabs.find((x) => x.id === 'asked').count = this.actionsListAsked.totalCount;
          this.spinner.hide();
          this.superTableLoaded = true;
        },
        error: (error) => {
          console.error('Error : ', error);
          this.spinner.hide();
          this.toastr.error('Impossible de charger les actions!');
        },
      });
    }
    if (type === 'assignedToMyTeam') {
      this.firstAssignedToMyTeam = (pageNumber - 1) * pageSize.value;
      const data: MailsEcheancierParams = {
        typeAction: 'AssignedToMyTeam',
        actionsEnCoursOnly: true,
        nePasInclurePourInformation: true,
        pageNumber: pageNumber,
        pageSize: pageSize.value,
        action: this.actionSearchDropdown,
        userIds: this.actionMembresServiceSearchDropdown,
      };
      if (!this.actionSearchDropdown) {
        delete data.action;
      }
      if (!this.actionMembresServiceSearchDropdown) {
        delete data.userIds;
      }
      this.mailsService.getEcheancier(data).subscribe({
        next: (response) => {
          this.actionsListAssignedToMyTeam.items = response.items.map(
            (item) => new Action(item, this.allUsers, 'AssignedToMyTeam', this.services, this.groups)
          );
          this.actionTabs.find((x) => x.id === 'assignedToMyTeam').count = this.actionsListAssignedToMyTeam.totalCount;
          this.spinner.hide();
          this.superTableLoaded = true;
        },
        error: (error) => {
          console.error('Error : ', error);
          this.toastr.error('Impossible de charger les actions!');
        },
      });
    }
  }

  changePageSize(event, type): void {
    switch (type) {
      case 'all':
        this.firstAll = 0;
        break;
      case 'week':
        this.firstWeek = 0;
        break;
      case 'finished':
        this.firstFinished = 0;
        break;
      case 'asked':
        this.firstAsked = 0;
        break;
      case 'assignedToMyTeam':
        0;
        break;
    }
    this.sizeChoiceList.find((x) => x.label === type).value = event.value;
    this.paginate(type, 1);
  }

  /**
   * Retreive contact with his ID
   * @param id contactId
   * Add name to actualUser connected array
   */ /**
 
  */
  getContactById(id: number): Observable<ContactDto> {
    return this.contactsService.fetchContact(id, 'iAdmin');
  }

  /**
   * Method called when you switch tabs and it switch with this clicked
   * @param event new tabs
   */
  receiveActionTabs(event: ITab): void {
    this.searchString = null;
    this.dataSearch = null;
    const temp = this.sizeChoiceList.find((x) => x.label === event.id);
    this.sizeChoice = temp.value;
    this.actionSearchDropdown = null;
    this.actionMembresServiceSearchDropdown = null;
  }

  public changeCurrentTabId(event: 'all' | 'week' | 'finished' | 'asked' | 'assignedToMyTeam'): void {
    this.actionTabsActive = event;
  }

  /**
   * Call on click in action row
   * open modal to show a form
   * @param column : action selected
   */
  answerToAction(column): void {
    this.responseStatus = column.statut;
    this.showActionResponse = true;

    // Building dropdown  (label - value)
    const status = [];
    this.actionStatus.map((s) => {
      status.push({
        label: s.description,
        value: s.description,
        id: s.id,
        ordreAffichage: s.ordreAffichage,
      });
    });

    const ref = this.dialogService.open(ActionResponseModalComponent, {
      dismissableMask: true,
      closable: true,
      header: 'Envoyer une réponse',
      width: '70vw',
      baseZIndex: 1000,
      data: {
        appConfig: this.appConfig,
        currentAction: column,
        status: status,
        accuseDeReponse: column.action.accuseDeReponse,
      },
    });

    ref.onClose.subscribe({
      next: (value: { replySuccess: boolean; isFromFlowAndProcessed?: boolean }) => {
        value?.replySuccess ? this.initData() : '';
      },
    });
  }

  openMail(column): void {
    const url = '/private/ic/tabs/';
    const config = environment;
    window.open(config.baseUrl + url + column.mailId);
  }

  getColumns(Hidecolumnaction?: boolean): void {
    const cols = [
      {
        field: 'mailId',
        header: 'ID courrier',
        format: (_value, item) => {
          if (item.mailId) {
            return item.mailId.toString();
          }
        },
        click: (column) => {
          this.openMail(column);
        },
      },
      {
        field: 'demandeur',
        header: 'Demandeur',
        format: (_value, item) => {
          let user = null;
          user = this.allUsers.filter((x) => x.userId === item.action.transmissionUserId);
          if (user.length > 0) {
            return (
              (user[0].contactForUser.prenom ? user[0].contactForUser.prenom : '') +
              ' ' +
              (user[0].contactForUser.nom ? user[0].contactForUser.nom : '')
            );
          } else {
            return ' ';
          }
        },
        click: (column) => {
          this.openMail(column);
        },
      },
      {
        field: 'contactiAdminId',
        header: 'Destinataire',
        format: (_value, item) => {
          if (item?.contact?.userId) {
            return (
              (item.contact.contactForUser.prenom ? item.contact.contactForUser.prenom : '') +
              ' ' +
              (item.contact.contactForUser.nom ? item.contact.contactForUser.nom : '')
            );
          } else if (item.action.groupeId || item.action.serviceId) {
            return item.action.name ? item.action.name : ' ';
          } else {
            return ' ';
          }
        },
        click: (column) => {
          this.openMail(column);
        },
      },
      {
        field: 'transmisDate',
        header: 'Date de transmission',
        format: (_value, item) => {
          if (item.action.transmisDate) {
            return moment(item.action.transmisDate).format('DD/MM/YYYY');
          } else {
            return '/';
          }
        },
        click: (column) => {
          this.openMail(column);
        },
        sort: (a, b, order) => {
          const val1 = moment(a, 'DD/MM/YYYY').isValid() ? moment(a, 'DD/MM/YYYY').unix() : null;
          const val2 = moment(b, 'DD/MM/YYYY').isValid() ? moment(b, 'DD/MM/YYYY').unix() : null;
          if (val1 === null) return 1;
          else if (val2 === null) return -1;
          else return val1 < val2 ? 1 * order : -1 * order;
        },
        sortable: true,
      },
      {
        field: 'actione',
        header: "Type d'action",
        format: (_value, item) => {
          if (item.action.action) {
            return item.action.action;
          } else {
            return '/';
          }
        },
        click: (column) => {
          this.openMail(column);
        },
      },
      Hidecolumnaction === false
        ? {
          field: 'statut',
          header: "Statut de l'action",
          format: (_value, item) => {
            if (item.action.statut) {
              return item.action.statut;
            } else {
              return '/';
            }
          },
          click: (column) => {
            this.openMail(column);
          },
        }
        : {},
      {
        field: 'echeance',
        header: "Date d'écheance",
        format: (_value, item) => {
          if (item.action.echeance) {
            return moment(item.action.echeance).format('DD/MM/YYYY');
          } else {
            return '/';
          }
        },
        click: (column) => {
          this.openMail(column);
        },
        sort: (a, b, order) => {
          const val1 = moment(a, 'DD/MM/YYYY').isValid() ? moment(a, 'DD/MM/YYYY').unix() : null;
          const val2 = moment(b, 'DD/MM/YYYY').isValid() ? moment(b, 'DD/MM/YYYY').unix() : null;
          if (val1 === null) return 1;
          else if (val2 === null) return -1;
          else return val1 < val2 ? 1 * order : -1 * order;
        },
        sortable: true,
      },
      {
        field: 'message',
        header: 'Message',
        format: (_value, item) => {
          if (item.action.message) {
            const msg = item.action.message && item.action.message.length > 30 ? item.action.message.substr(0, 30) + '...' : item.action.message;
            return `<span class="wordBreak">${msg}</span>`;
          } else {
            return '/';
          }
        },
        tooltip: (item) => {
          return item.messageNoBreak;
        },
        click: (column) => {
          this.openMail(column);
        },
      },
      {
        field: 'objet',
        header: 'Objet',
        format: (_value, item) => {
          if (item.objet) {
            const temp = item.objet;
            return temp.length > 30 ? temp.substr(0, 30) + '...' : temp;
          } else {
            return '/';
          }
        },
        tooltip: (item) => {
          return item.objetNoBreak;
        },
        click: (column) => {
          this.openMail(column);
        },
      },
      {
        field: 'serviceProprietaireId',
        header: 'Service',
        format: (_value, item) => {
          if (item.serviceProprietaireId && this.services.length > 0) {
            return this.services.find((x) => x.id === item.serviceProprietaireId)?.description ?? '';
          } else {
            return '/';
          }
        },
        click: (column) => {
          this.openMail(column);
        },
      },
      {
        field: 'reponseDisplayed',
        header: 'Réponse',
        sortable: false,
        align: 'right',
        format: (_value, item) => {
          if (item.action.reponse) {
            return item.action.reponse;
          } else {
            return `Aucune réponse`;
          }
        },
      },
      {
        field: 'actionId',
        header: 'ID Action',
        visible: false,
        format: (_value, item) => {
          return item.action.id;
        },
      },
      {
        field: 'traiteLe',
        header: 'Terminé le',
        visible: true,
        format: (_value, item) => {
          if (item.action.traiteLe) {
            return moment(item.action.traiteLe).format('DD/MM/YYYY');
          } else {
            return '/';
          }
        },
      },
      {
        field: 'actionss',
        header: 'Action à traiter',
        sortable: false,
        align: 'right',
        format: (_value, item) => {
          if (item.action.rights.canReply) {
            return `<div class="btn lightBlueButton d-block w-100"><i class="bi bi-lightning-charge-fill"></i></div>`;
          } else {
            return '/';
          }
        },

        click: (item) => {
          if (item.action.rights.canReply) {
            this.answerToAction(item);
          }
        },
      },
    ];
    this.columns = cols.filter((column) => column.field);
    this.initData();
  }
  searchAction(): void {
    this.dataSearch = this.searchString;
  }

  changeSubTab(event): void {
    this.typeOfActionChosen = event;
    this.firstAsked = 0;
    this.paginate('asked', 1);
  }

  getSelectButtonValue(type): void {
    localStorage.setItem('iCourrier_Actions_Table_List_Visibility_Value', this.valueJustifyOption.state);
    this.sizeChoice = this.sizeChoiceList.find((x) => x.label === type).value;
  }

  onPageChange(event, type): void {
    switch (type) {
      case 'all':
        this.firstAll = event.first;
        break;
      case 'week':
        this.firstWeek = event.first;
        break;
      case 'finished':
        this.firstFinished = event.first;
        break;
      case 'asked':
        this.firstAsked = event.first;
        break;
      case 'assignedToMyTeam':
        this.firstAssignedToMyTeam = event.first;
        break;
    }
    this.sizeChoiceList.find((x) => x.label === type).value = event.rows;
    this.paginate(type, event.page + 1); //! pas enlever le +1, ou alors vérifier le retour d'event si Angular à changé!
  }
}
